import { useMemo } from 'react';
import { useAuth } from '../contexts/session';
import {  fetchGet as rawFetchGet, fetchPost as rawFetchPost  } from '../helpers/apiFetch/fetch';

const useApi = () => {
    const auth = useAuth();
    

    return useMemo(() => ({
        /**
         * Executes a GET request with optional credentials/data.
         * @type {(endpoint: string, includeCredentials: boolean, attemps: number)}
         * 
         * @returns {Promise<Response>}
         */
        fetchGet: (...args) => {
            return rawFetchGet(auth, ...args);
        },
        /**
         * Executes a POST request with optional credentials/data.
         * @type {(endpoint: string, payload: object, includeCredentials: boolean, jsonStringify: boolean, headers: object, attempts: number)}
         * 
         * @returns {Promise<Response>}
         */
        fetchPost: (...args) => {
            return rawFetchPost(auth, ...args);
        }
    }), [auth]);
};

export { useApi };